import { useTranslation } from 'react-i18next';
import blockedItems from './blockedItems.json';
import './wipeblock.css'
import { useContext, useState } from 'react';
import { Context } from '../../../index';
import Tippy from '@tippyjs/react';

const BlockItem = ({item}:any) => {
    const { t } = useTranslation();
    const {store} = useContext(Context);

    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <Tippy delay={150}
            content={
                <div className='c-grey-250'>{t(`items.${item}`)}</div>
            }
        >
            <div className={`wipeblock__item ${!imageLoaded ? 'loading':''}`}>
                <div className="wipeblock__item__image_wrap">
                    <img className="wipeblock__item__image" 
                        src={store.resizeImg(`${item}.png`)}
                        onLoad={() => setImageLoaded(true)}
                        style={{
                            opacity: imageLoaded ? 1: 0,
                        }}
                    />
                </div>
            </div>
        </Tippy>
    )
}

function BlockCategory({t,languages,category,time,items}:any) {
    function timeSelector() {
        if (languages.includes('ru')) {
            const last_num = time%10;
            if (time > 10 && [11, 12, 13, 14].includes(time%100)) return t('wipeblock.categoryTime_other', {categoryTime: time});
            if (last_num === 1) return t('wipeblock.categoryTime_one', {categoryTime: time});
            if ([2,3,4].includes(last_num)) return t('wipeblock.categoryTime_few', {categoryTime: time});
            if ([5,6,7,8,9, 0].includes(last_num)) return t('wipeblock.categoryTime_other', {categoryTime: time});
        }
        else {
            return time%10===1 ? t('wipeblock.categoryTime_one', {categoryTime: time}): t('wipeblock.categoryTime_other', {categoryTime: time});
        }
    }
    return(
        <>
            <div className={`wipeblock__category _${category}`}>
                <div className="item-2 wipeblock__time">
                    { timeSelector() }
                </div>
                <div className="wipeblock__items">
                {items.map((item:any, i:number) => (
                    <BlockItem 
                    key = {item+i}
                    item = {item}
                    />
                ))}
                </div>
            </div>
        </>
    )
}

export default function Body() {
    const { t, i18n } = useTranslation();
    const languages = i18n.languages;
    return(
        <>
            <main>
                <div className="xbox__body wipeblock">
                    <div className="xbox__div-1 wipeblock__table">
                        <BlockCategory t={t} languages={languages} category={1} time={1} items={blockedItems.category_1}/>
                        <BlockCategory t={t} languages={languages} category={2} time={2} items={blockedItems.category_2}/>
                        <BlockCategory t={t} languages={languages} category={3} time={3} items={blockedItems.category_3}/>
                        <BlockCategory t={t} languages={languages} category={4} time={5} items={blockedItems.category_4}/>
                        <BlockCategory t={t} languages={languages} category={5} time={23} items={blockedItems.category_5}/>
                        <BlockCategory t={t} languages={languages} category={6} time={24} items={blockedItems.category_6}/>
                        <BlockCategory t={t} languages={languages} category={7} time={26} items={blockedItems.category_7}/>
                    </div>
                </div>
            </main>
        </>
    )
}